import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacyTabs';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  borderColor: '#a8cf38',
  tabColor: palette.primary.normal
});

const styles = ({ legacyTabs }) => (legacyTabs ? {
  root: {
    '& .nav-tabs': {
      '& > li > a': {
        fontWeight: 'normal',
        textTransform: 'uppercase'
      },
      '& li.active > a': {
        color: legacyTabs.tabColor,
        borderBottom: `3px solid ${legacyTabs.borderColor}`
      }
    }
  }
} : {});

addModuleStyles(styles, themeKey, defaultTheme);
